import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class VeiculosService extends Service{

  protected url: string = this.dominio+"/adm/veiculos/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  getPaginacaoArquivos(pagina, limit, relacionamentos = null, filtros = null){

    let headers = this.getHeaderLogado();
    let urlRelacionamentos = '';
    let urlFiltros = '';

    if(relacionamentos){
      urlRelacionamentos = 'relations='+JSON.stringify(relacionamentos)+'&';
    }

    if(filtros){
      urlFiltros = 'filters='+JSON.stringify(filtros)+'&';
    }

    return this.http.get(this.url+'arquivos/?'+ urlRelacionamentos + urlFiltros +'pages={"page":'+pagina+',"limit":'+limit+'}', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  apagarArquivo(id){
    let headers = this.getHeaderLogado();

    return this.http.delete(this.url+'arquivos/' + id, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  updateOleo(id, km_troca_oleo){
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id + '/troca-oleo', JSON.stringify({ km_troca_oleo }), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/veiculos/veiculos.service.ts